import  {useEffect, useState} from 'react'
import {PublisherData} from './AdminDashboardByPublisher';
import ReactEcharts from 'echarts-for-react';

interface Props {
    pubDat: PublisherData[],
    style: {},
    publisher
}

const BarChartByPublisher = (props: Props) => {
    const [option, setOption] = useState<any>()

    useEffect(() => {
        loadOptions()
    }, [props.publisher, props.pubDat])

    const loadOptions = () => {

        let reqData: any[] = []
        let winData: any[] = []
        let impData: any[] = []
        let pubData: any[] = []
        let viewData: any[] = []
        let clickData: any[] = []
        let vastStartData: any[] = []
        let vastCompleteData: any[] = []

        if (props.publisher) {
            props.pubDat.forEach(d => {
                if (!props.publisher || d.name === props.publisher) {
                    pubData.push({value: d.name})
                    reqData.push({value: d.request})
                    winData.push({value: d.win})
                    impData.push({value: d.impression})
                    viewData.push({value: d.view})
                    clickData.push({value: d.click})
                    vastStartData.push({value: d.vastStart})
                    vastCompleteData.push({value: d.vastComplete})
                }
            });
        } else {
            reqData[0] = 0
            winData[0] = 0
            impData[0] = 0
            viewData[0] = 0
            clickData[0] = 0
            vastStartData[0] = 0
            vastCompleteData[0] = 0
            pubData[0] = 'Total'
            props.pubDat.forEach(d => {
                if (!props.publisher || d.name === props.publisher) {
                    reqData[0] += Number.parseInt(d.request)
                    winData[0] += Number.parseInt(d.win)
                    impData[0] += Number.parseInt(d.impression)
                    viewData[0] += Number.parseInt(d.view)
                    clickData[0] += Number.parseInt(d.click)
                    vastStartData[0] += Number.parseInt(d.vastStart)
                    vastCompleteData[0] += Number.parseInt(d.vastComplete)
                }
            });
        }

        const chartOption = {
            title: {
                text: 'Events',
                subtext: 'by Publisher',
                // textStyle: {fontSize: 'auto'},
                left: 'left'
            },
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            legend: {
                type: 'scroll',
                top: '6%',
                left: 'center'
            },
            grid: {
                top: '12%',
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            xAxis: [
                {
                    type: 'category',
                    axisLabel: {
                        interval: 0,
                        // rotate: 45
                    },
                    data: pubData
                }
            ],
            yAxis: [
                {
                    type: 'value',
                    nameTextStyle: {
                        padding: [0, 0, 0, -10],
                        align: 'left',
                    }

                }
            ],
            series: [
                {
                    name: 'Requests',
                    type: 'bar',
                    barMaxWidth: 40,
                    emphasis: {
                        focus: 'series'
                    },
                    label: {
                        show: true,
                        formatter: '{a} - {c}',
                        rotate: 90,
                        align: 'left',
                        verticalAlign: 'middle',
                        position: 'insideBottom',
                        distance: 15,
                        fontSize: 16
                    },
                    data: reqData
                },
                {
                    name: 'Win',
                    type: 'bar',
                    barMaxWidth: 40,
                    emphasis: {
                        focus: 'series'
                    },
                    label: {
                        show: true,
                        formatter: '{a} - {c}',
                        rotate: 90,
                        align: 'left',
                        verticalAlign: 'middle',
                        position: 'insideBottom',
                        distance: 15,
                        fontSize: 16
                    },
                    data: winData
                },
                {
                    name: 'Impressions',
                    type: 'bar',
                    barMaxWidth: 40,
                    emphasis: {
                        focus: 'series'
                    },
                    label: {
                        show: true,
                        formatter: '{a} - {c}',
                        rotate: 90,
                        align: 'left',
                        verticalAlign: 'middle',
                        position: 'insideBottom',
                        distance: 15,
                        fontSize: 16
                    },
                    data: impData
                },
                {
                    name: 'Views',
                    type: 'bar',
                    barMaxWidth: 40,
                    emphasis: {
                        focus: 'series'
                    },
                    label: {
                        show: true,
                        formatter: '{a} - {c}',
                        rotate: 90,
                        align: 'left',
                        verticalAlign: 'middle',
                        position: 'insideBottom',
                        distance: 15,
                        fontSize: 16
                    },
                    data: viewData
                },
                {
                    name: 'Clicks',
                    type: 'bar',
                    barMaxWidth: 40,
                    emphasis: {
                        focus: 'series'
                    },
                    label: {
                        show: true,
                        formatter: '{a} - {c}',
                        rotate: 90,
                        align: 'left',
                        verticalAlign: 'middle',
                        position: 'insideBottom',
                        distance: 15,
                        fontSize: 16
                    },
                    data: clickData
                },
                {
                    name: 'VastStarts',
                    type: 'bar',
                    barMaxWidth: 40,
                    emphasis: {
                        focus: 'series'
                    },
                    label: {
                        show: true,
                        formatter: '{a} - {c}',
                        rotate: 90,
                        align: 'left',
                        verticalAlign: 'middle',
                        position: 'insideBottom',
                        distance: 15,
                        fontSize: 16
                    },
                    data: vastStartData
                },
                {
                    name: 'VastCompletes',
                    type: 'bar',
                    barMaxWidth: 40,
                    emphasis: {
                        focus: 'series'
                    },
                    label: {
                        show: true,
                        formatter: '{a} - {c}',
                        rotate: 90,
                        align: 'left',
                        verticalAlign: 'middle',
                        position: 'insideBottom',
                        distance: 15,
                        fontSize: 16
                    },
                    data: vastCompleteData
                },
            ]
        };

        setOption(chartOption)
    };

    return  <div>
                {option && <ReactEcharts style={props.style} option={option}/>}
            </div>
}

export default BarChartByPublisher
